<template>
    <form @submit.prevent="updateUser" action="#">
        <div class="form-group">
            <label>{{$t('profile.full_name')}}</label>
            <input v-model="form.name" type="text" class="form-control">
        </div>

        <div class="form-group">
            <label>{{$t('profile.email')}}</label>
            <input v-model="form.email" type="email" disabled class="form-control">
        </div>

        <div class="form-group">
            <label>{{$t('profile.phone')}}</label>
            <input v-model="form.phone" type="text" class="form-control">
        </div>

        <div class="form-group">
            <label>{{$t('profile.language')}}</label>
            <language-select v-model="form.language"/>
        </div>

        <div class="alert alert-info" v-if="isLogoutRequired">
              {{$t('profile.logout_is_needed')}}
        </div>

        <div class="text-right">
            <BaseButtonSubmit
                :text="$t('profile.save_data')"
                :sendingText="$t('profile.saving_data')"
                :sending="saving || reloadingToken"
            />
        </div>
    </form>
</template>

<script>
    import LanguageSelect from "../../modules/Credentials/components/LanguageSelect";

    export default {
        name: "UserPersonalDataForm",
        components: {LanguageSelect},
        props: {
            user: {
                type: Object
            },
        },

        data() {
            return {
                form: {
                    email: this.user ? this.user.email : null,
                    phone: this.user ? this.user.phone : null,
                    name: this.user ? this.user.name  : null,
                    active: this.user ? this.user.active  : true,
                    language: this.user ? this.user.language : null,
                },
                saving: false,
                reloadingToken: false,
                errors: []
            }
        },

       computed: {
          authMethod() {
            return this.$store.getters['Auth/tokenPayload'].auth_method;
          },

          isLogoutRequired() {
            return this.form.language !== this.user.language && this.authMethod !== 'DEALER_ID';
          },

          isReloadTokenRequired() {
            return this.form.language !== this.user.language;
          }
       },

       methods: {
            updateUser() {
                this.saving = true;
                this.errors = [];
                let isLogoutRequired = this.isLogoutRequired;
                let isReloadTokenRequired = this.isReloadTokenRequired;
                this.$store
                    .dispatch('User/updateUser', {uuid: this.user.uuid, data: this.form})
                    .then(() => {
                      if(isLogoutRequired) {
                        return this.$router.push({name: 'Logout'})
                      }
                      if (isReloadTokenRequired) {
                        this.reloadingToken = true;
                        this.$store.dispatch('Auth/reloadToken')
                          .finally(() => this.reloadingToken = false);
                      }
                    })
                    .catch(({errors}) => {
                        this.errors = errors
                    })
                    .finally(() => this.saving = false);
            }
        }
    }
</script>

<style scoped>

</style>